/**
 * ESMap/ESCityMap地图通用工具方法
 * 如果是ESCityMap则各个方法中需要提供bid（地图ID）
 */
const CommonTools = {
    /**
   * 创建图片标注
   * @param {object} params - 参数配置
   * @param {string} params.id - 标注ID
   * @param {string} params.name - 标注name
   * @param {string} params.bid - 地图bid
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {string} params.url - 图片地址
   * @param {(number|object)} params.size - 图片大小 或者 size:{w:32,h:64}
   * @param {boolean} params.spritify - 跟随地图缩放变化大小，默认为true，可选参数
   * @param {number} params.offsetHeight - 离地板高度
   * @param {number} params.showLevel - 显示等级
   * @param {boolean} params.isGlow - 是否开启闪烁
   * @param {string} params.glowColor - 发光颜色
   * @param {number} params.angle - 角度
   * @param {boolean} params.up - 垂直：true, 水平：false
   * @param {boolean} params.seeThrough - 是否开启穿透
   * @param {function} params.callback 回调返回标注对象
   */
    addImageMarker: function (params) {
        return new esmap.ESImageMarker({
            bid: params.bid,
            x: params.x,
            y: params.y,
            url: params.url,
            size: params.size,
            spritify: true,
            height: params.offsetHeight,
            showLevel: params.showLevel,
            id: params.id,
            name: params.name,
            glow: params.isGlow,
            center: params.center,
            glowColor: params.glowColor,
            angle: params.angle,
            up: params.up,
            seeThrough: params.seeThrough,
            callback: function (e) {
                params.callback ? params.callback(e) : null
            },
        })
    },
    /**
   * 创建文字标注
   * @param {object} params - 参数配置
   * @param {string} params.id - 标注ID
   * @param {string} params.name - 标注name
   * @param {string} params.bid - 地图bid
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {string} params.text - 文本内容
   * @param {(number|object)} params.scale 文字大小，默认是1
   * @param {number} params.offsetHeight - 离地板高度
   * @param {number} params.showLevel - 显示等级
   * @param {string} params.image - 是否绑定图标
   * @param {string} params.imageAlign - 图标布局
   * @param {string} params.imageSize - 图标大小
   * @param {boolean} params.seeThrough - 是否开启穿透
   * @param {function} params.callback 回调返回标注对象
   */
    addTextMarker: function (params) {
        return new esmap.ESTextMarker({
            bid: params.bid,
            id: params.id,
            x: params.x,
            y: params.y,
            name: params.name,
            text: params.text,
            fontsize: params.fontsize,
            scale: params.scale,
            height: params.offsetHeight,
            showLevel: params.showLevel,
            image: params.image,
            imageAlign: params.imageAlign,
            imageSize: params.imageSize,
            seeThrough: params.seeThrough,
            callback: function (e) {
                params.callback ? params.callback() : null
            },
        })
    },
    /**
   * 创建气泡标注
   * @param {object} params - 参数配置
   * @param {string} params.bid - 地图bid
   * @param {number} params.fnum - 地图楼层
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.offset - 离楼层地板高度
   * @param {string} params.html - 气泡内容自定义HTML模板
   * @param {string} params.className - 气泡内部容器class样式
   * @param {function} params.callback 气泡创建完成后回调返回内部dom对象
   */
    addPopMarker: function (params) {
        return new esmap.ESPopMarker({
            id: params.id,
            name: params.name,
            mapCoord: {
                x: params.x,
                y: params.y,
                height: params.offset,
                fnum: params.fnum || 1,
            },
            bid: params.bid,
            content: params.html,
            className: params.className,
            showLevel: params.showLevel,
            created: function (dom) {
                params.callback ? params.callback(dom) : null
            },
        })
    },
    /**
     * 创建导航线样式标注
     * @param {*} params 
     * @param {string} params.color - 线颜色
     * @param {number} params.lineWidth - 线宽
     * @param {number} params.alpha - 线宽
     * @returns 
     */
    addNavLineMarker: function (params) {
        var lineStyle = {
            color: params.color,
            lineWidth: params.lineWidth,
            alpha: params.alpha,
            lineType: params.lineType || esmap.ESLineType.ESARROW,
            fixedWidth: params.fixedWidth,
            transparent: params.transparent,
            arrow: params.arrow,
            lineWidthMeter: params.lineWidthMeter,
            noAnimate: params.noAnimate,  //控制箭头动画
            seeThrough: params.seeThrough,
            alphaSplit: params.alphaSplit,
        }
        return new esmap.ESLineMarker({ id: params.id || 1, bid: 0, points: params.points, style: lineStyle })
    },
    /**
   * 创建贴图线标注
   * @param {object} params - 参数配置
   * @param {string} params.id - 贴图线ID(建议唯一性，方便查找对象)
   * @param {string} params.imgUrl - 贴图线的图片地址
   * @param {object[]} params.points - 线的点集 {bid,fnum,x,y,offset}
   * @param {boolean} params.isTubeLine - 是否是管道线
   * @param {number} params.lineWidth - 线宽
   * @param {number} params.repeat - 纹理重复调参
   * @param {string} params.color - 线颜色
   * @param {number} params.animateSpeed - 贴图流动速度
   * @param {boolean} params.arrow - 是否绘制箭头
   * @param {boolean} params.seeThrough - 是否开启穿透
   */
    addImgLineMarker: function (params) {
        var lineStyle = {
            url: params.imgUrl,
            lineType: esmap.ESLineType.TEXTURE,
            lineMode: params.isTubeLine ? esmap.ESLineMode.CIRCLE : esmap.ESLineMode.PLANE,
            lineWidthMeter: true, //
            lineWidth: params.lineWidth,
            repeat: params.repeat,
            color: params.color,
            //esmap.ESLineMode.PLANE:平面 ，esmap.ESLineMode.CIRCLE:管道
            closed: false, //是否自动连接起点终点
            pickable: true,
            metalness: false, //材质金属性
            reverseAnimate: false, //是否反转贴图流动方向
            animateSpeed: params.animateSpeed, //
            arrow: params.arrow, //
            fixedWidth: params.fixedWidth,
            transparent: params.transparent,
            seeThrough: params.seeThrough,
        }
        return new esmap.ESLineMarker({ id: params.id || 1, bid: 0, points: params.points, style: lineStyle })
    },
    /**
   * 创建多边形标注
   * @param {object} params - 参数配置
   * @param {string} params.bid - 地图bid
   * @param {string} params.id - ID(建议唯一性，方便查找对象)
   * @param {number} params.alpha - 透明度
   * @param {object[]} params.points - 多边形的点集 {bid,fnum,x,y,offset}
   * @param {boolean} params.noAnimate - 是否是管道线
   * @param {number} params.lineWidth - 线宽
   * @param {number} params.offsetHeight - 离楼层地板高度
   * @param {string} params.color - 多边形颜色
   * @param {string} params.lineType - 边缘线类型
   * @param {boolean} params.pickable - 是否允许可点击
   * @param {boolean} params.seeThrough - 是否开启穿透
   */
    addPolygonMarker: function (params) {
        return new esmap.ESPolygonMarker({
            bid: params.bid,
            id: params.id,
            alpha: params.alpha,
            color: params.color,
            pickable: params.pickable,
            lineWidth: params.lineWidth,
            height: params.offsetHeight,
            points: params.points,
            lineType: params.lineType,
            fixedWidth: true,
            noAnimate: params.noAnimate,
            seeThrough: params.seeThrough,
        })
    },
    /**
   * 创建模型标注
   * @param {object} params - 参数配置
   * @param {string} params.bid - 地图bid
   * @param {string} params.id - ID(建议唯一性，方便查找对象)
   * @param {string} params.name - name
   * @param {string} params.url - 模型文件地址
   * @param {number} params.size - 模型大小
   * @param {number} params.angle - 模型旋转角
   * @param {number} params.offsetHeight - 离楼层地板高度
   * @param {boolean} params.showLevel - 是否允许可点击
   * @param {function} params.callback 回调返回标注对象
   */
    addModelMarker: function (params) {
        return new esmap.ES3DMarker({
            bid: params.bid,
            x: params.x,
            y: params.y,
            id: params.id,
            name: params.name,
            url: params.url,
            size: params.size || 4,
            onError: function (e) {
                console.error(e)
            },
            angle: params.angle || 0,
            height: params.offsetHeight || 0, //高度
            showLevel: params.showLevel,
            callback: function (e) {
                params.callback ? params.callback(e) : null
            },
        })
    },
    /**
   * 相机飞行聚焦
   * @param {object} params - 参数配置
   * @param {number} params.x - 聚焦点墨卡托坐标x
   * @param {number} params.y - 聚焦点墨卡托坐标y
   * @param {number} params.z - 聚焦高度
   * @param {number} params.radius - 最终离聚焦点距离
   * @param {string} params.pitchAngle -
   * @param {string} params.directionAngle -
   * @param {number} params.time - 飞行秒数
   * @param {function} params.callback 回调函数
   */
    cameraFlyFocus: function (map, params) {
        // TODO: 待上层实现调用该方法UI禁止点击问题
        params.startCallback ? params.startCallback() : null
        document.querySelector('.map_event_shade').style.display = 'block'
        map.cameraFlyTo({
            x: params.x,
            y: params.y,
            z: params.z,
            radius: params.radius,
            pitchAngle: params.pitchAngle || 45,
            directionAngle: params.directionAngle || 0,
            time: params.time,
            callback: function () {
                params.endCallback ? params.endCallback() : null
                document.querySelector('.map_event_shade').style.display = 'none'
            },
        })
    },
    /**
   * 检查当前点是否在区域中
   * @param {Object} point 当前点x,y
   * @param {Array} areaCoords 区域点集
   */
    checkIsInExtent: function (point, areaCoords) {
        return esmap.ESMapUtil.pointInArea(point, areaCoords)
    },
    /**
   * 添加圆圈扩散特效
   * @param {object} params - 参数配置
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.offsetHeight - 离楼层地板高度
   * @param {number} params.radius - 最终离聚焦点距离
   * @param {number} params.speed - 动画速度，默认0.01
   * @param {string} params.color - 颜色
   * @param {boolean} params.isSpread - true则扩散， false则接收
   */
    addCircleRippleEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CIRCLE_RIPPLE, {
            x: params.x,
            y: params.y,
            height: params.offsetHeight,
            color: params.color,
            opacity: params.opacity,
            isSpread: params.isSpread,
            radius: params.radius,
            speed: params.speed,
            isShine: params.isShine,
            seeThrough: params.seeThrough,
        })
    },
    /**
   * 添加区域围墙特效
   * @param {object} params - 参数配置
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.offsetHeight - 离楼层地板高度
   * @param {number} params.radius - 半径
   * @param {string} params.color - 颜色
   * @param {string} params.groundColor - 是否使用地板，地板颜色 TODO: 待分开参数
   * @param {string} params.focuseColor - 聚焦颜色
   * @param {string} params.scrollImgUrl - 应用横向滚动图
   * @param {boolean} params.scrollClockWise - 是否顺时针滚动
   * @param {boolean} params.seeThrough - 是否穿透显示
   */
    addExtentWallEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.EXTENT_WALL, {
            height: params.height,
            color: params.color,
            focuseColor: params.focuseColor,
            groundColor: params.groundColor,
            wallHeight: params.wallHeight,
            extentList: params.extentList,
            isTransparentLight: false,
            isShine: true,
            scrollImgUrl: params.scrollImgUrl,
            scrollClockWise: params.scrollClockWise,
            seeThrough: params.seeThrough,
        })
    },
    /**
   * 添加轨迹特效线
   * @param {object} params - 参数配置
   * @param {number} params.height - 离楼层地板高度
   * @param {number} params.lineWidth - 线宽
   * @param {string} params.color - 颜色
   * @param {boolean} params.seeThrough - 是否穿透显示
   */
    addTrackLineEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.ROUTES_LINE, {
            color: params.color,
            height: params.height,
            lineWidth: params.lineWidth,
            isShine: true,
            seeThrough: params.seeThrough,
        })
    },
    /**
   * 添加闪烁点集特效
   * @param {object} params - 参数配置
   * @param {number} params.height - 离楼层地板高度
   * @param {number} params.pointSize - 点的大小
   * @param {string} params.color - 颜色
   * @param {object[]} params.points - 点集
   * @param {boolean} params.seeThrough - 是否穿透显示
   */
    addTwinklePointsEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.POINTS, {
            pointSize: params.pointSize,
            color: params.color,
            points: params.points,
            height: params.height,
            animateType: params.animateType,
            isShine: true,
            showLevel: params.showLevel,
            seeThrough: params.seeThrough,
            period: params.period
        })
    },
    /**
   * 添加流动点云线
   * @param {object} params 配置参数
   * @param {number} params.gapDistance - 点与点之间的间隔
   * @param {number} params.activeNum - 闪烁点数目
   * @param {number} params.pointSize - 点的大小
   * @param {string} params.color - 颜色
   * @param {object[]} params.points - 点集
   * @param {boolean} params.seeThrough - 是否穿透显示
   */
    addPointsLineEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.POINTS_LINE, {
            gapDistance: params.gapDistance,
            activeNum: params.activeNum,
            pointSize: params.pointSize,
            color: params.color,
            points: params.points,
            isShine: true,
            seeThrough: params.seeThrough,
        })
    },
    /**
   * 添加圆圈旋转特效
   * @param {object} params 配置参数
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.height - 离楼层地板高度
   * @param {number} params.radius - 半径
   * @param {string} params.color - 颜色
   * @param {boolean} params.seeThrough - 是否穿透显示
   */
    addCircleRotateEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CIRCLE_ROTATE, {
            x: params.x,
            y: params.y,
            height: params.height,
            color: params.color,
            radius: params.radius,
            isShine: true,
            seeThrough: params.seeThrough,
        })
    },
    /**
   * 添加指示位置盒子旋转特效
   * @param {object} params 配置参数
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.height - 离楼层地板高度
   * @param {number} params.radius - 半径
   * @param {string} params.color - 颜色
   */
    addCubeFloatEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CUBE_FLOAT, {
            x: params.x,
            y: params.y,
            height: params.height,
            radius: params.radius,
            color: params.color,
            isShine: true,
        })
    },
    /**
   * 添加圆柱形环带上下漂浮动画
   * @param {object} params 配置参数
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.height - 漂浮环上下运动往返点高度
   * @param {number} params.radius - 半径
   * @param {number} params.cylinderHeight - 漂浮环自身宽度
   * @param {number} params.moveHeight - 漂浮环移动高度
   */
    addCylinderFloatEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_FLOAT, {
            x: params.x,
            y: params.y,
            height: params.height,
            radius: params.radius,
            imgUrl: params.imgUrl,
            cylinderHeight: params.cylinderHeight,
            moveHeight: params.moveHeight,
            isShine: true,
        })
    },
    /**
   * 添加圆柱形环带上下漂浮动画
   * @param {object} params 配置参数
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.height - 漂浮环上下运动往返点高度
   * @param {number} params.radius - 半径
   * @param {number} params.cylinderHeight - 漂浮环自身宽度
   * @param {number} params.moveHeight - 漂浮环移动高度
   */
    addCylinderSpreadEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_SPREAD, {
            x: params.x,
            y: params.y,
            height: params.height,
            radius: params.radius,
            scanHeight: params.scanHeight,
        })
    },
    /**
   * 添加圆柱形环带上下漂浮动画
   * @param {object} params 配置参数
   * @param {number} params.x - 墨卡托坐标x
   * @param {number} params.y - 墨卡托坐标y
   * @param {number} params.width - 数字条宽度
   * @param {object[]} params.points - 数字条位置点集（含高度）
   */
    addNumberUpEffect: function (params) {
        return new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.NUMBER_UP_BEAM, {
            x: params.x,
            y: params.y,
            width: params.width,
            points: params.points, // {x,y,height}
        })
    },
    /**
   * 设置建筑楼层透明
   * @param {object} building 园区sdk子地图对象
   * @param {number[]} fnums - 目标楼层数组
   * @param {number} opacity - 透明度
   * @param {number} time - 透明变化过渡时间
   * @param {string[]} excludes - 需要过滤不处理的layer name
   */
    setBuildingFloorAlpha: function (building, fnums, opacity, time, excludes) {
        for (let n of fnums) {
            building.setFloorAlpha({ fnum: n, time: time || 0, alpha: opacity, excludes: excludes || [] })
        }
    },
    /**
   * 恢复楼层透明处理
   * @param {object} building 园区sdk子地图对象
   * @param {number[]} fnums - 目标楼层数组
   * @param {number} time - 透明变化过渡时间
   */
    recoverBuildingFloorAlpha: function (building, fnums, time) {
        for (let n of fnums) {
            building.restoreFloorAlpha({ fnum: n, time: time || 0 })
        }
    },
}

export default CommonTools
